export default function SlantedBackground({
  backgroundColor,
  children,
}: any): JSX.Element {
  const styles = [backgroundColor ? ` bg-[#F0F4F2] ${backgroundColor}` : null]
    .filter(Boolean)
    .join(' ')
  return styles ? (
    <div className="SlantedBackground ">
      <div className={`slanted ${styles}`}>{children}</div>
    </div>
  ) : (
    <>{children}</>
  )
}
